// extracted by mini-css-extract-plugin
module.exports = {"floatNavigation":"styles-module--float-navigation--2tgh8","floatNavigation__link":"styles-module--float-navigation__link--3s7_o"};